import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const uploadScormOrHtmlShotClass = (
  isHTML,
  classId,
  fileExtension,
  fileName,
  isVariant,
  status,
  data
) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.MANAGE.UPLOAD_SCORM_OR_HTML_SHOTCLASS(
      isHTML,
      classId,
      fileExtension,
      fileName,
      isVariant,
      status
    ),
    data
  );
};

export default uploadScormOrHtmlShotClass;
